var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import Multiselect from "vue-multiselect";
import { SystemsClient, ImportControllerDataFromZipCommand, ImportControllerDataFromZipRequestModel, ImportControllerDataFromZipResponseModel } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { UploadErrorHelper } from "@/app/utils/upload-error-helper";
const systemsClient = new SystemsClient(window.apiUrl);
let ImportSystemFromZipModal = class ImportSystemFromZipModal extends Vue {
    constructor() {
        super(...arguments);
        this.show = false;
        this.selectedCompany = null;
        this.selectedSite = null;
        this.selectedFile = null;
        this.uploading = false;
        this.uploadProgress = 0;
        this.importResult = null;
        this.existingSystemWarning = null;
        this.showExistingSystemWarning = false;
        this.selectedImportOption = null;
        this.archiveExisting = false;
    }
    showModal() {
        this.show = true;
        this.resetForm();
    }
    resetForm() {
        this.selectedCompany = null;
        this.selectedSite = null;
        this.selectedFile = null;
        this.uploading = false;
        this.uploadProgress = 0;
        this.importResult = null;
        this.existingSystemWarning = null;
        this.showExistingSystemWarning = false;
        this.selectedImportOption = null;
        this.archiveExisting = false;
    }
    onModalHidden() {
        this.resetForm();
    }
    onFileSelected(event) {
        const target = event.target;
        if (target.files && target.files.length > 0) {
            this.selectedFile = target.files[0];
        }
        // Reset existing system warning when file changes
        this.existingSystemWarning = null;
        this.showExistingSystemWarning = false;
        this.selectedImportOption = null;
        this.archiveExisting = false;
    }
    onCompanyChanged() {
        this.selectedSite = null;
        this.existingSystemWarning = null;
        this.showExistingSystemWarning = false;
        this.selectedImportOption = null;
        this.archiveExisting = false;
    }
    onSiteChanged() {
        this.existingSystemWarning = null;
        this.showExistingSystemWarning = false;
        this.selectedImportOption = null;
        this.archiveExisting = false;
    }
    cancel() {
        if (!this.uploading) {
            this.show = false;
        }
    }
    importFile() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!this.canImport)
                return;
            this.uploading = true;
            this.uploadProgress = 0;
            this.importResult = null;
            try {
                // Read file as base64
                const base64String = yield this.readFileAsBase64(this.selectedFile);
                // Determine which mode to use
                const archiveMode = ((_a = this.existingSystemWarning) === null || _a === void 0 ? void 0 : _a.isDifferentLocation)
                    ? this.archiveExisting
                    : this.selectedImportOption === 'archive';
                const overrideMode = !((_b = this.existingSystemWarning) === null || _b === void 0 ? void 0 : _b.isDifferentLocation) && this.selectedImportOption === 'override';
                // Create the command
                const command = new ImportControllerDataFromZipCommand({
                    requestModel: new ImportControllerDataFromZipRequestModel({
                        zipFileBase64: base64String,
                        companyId: this.selectedCompany.value,
                        siteId: this.selectedSite.value,
                        archiveExistingSystem: archiveMode,
                        overrideExistingSystem: overrideMode
                    })
                });
                // Simulate upload progress
                const progressInterval = setInterval(() => {
                    if (this.uploadProgress < 90) {
                        this.uploadProgress += 10;
                    }
                }, 500);
                // Call the API
                const response = yield systemsClient.importFromZip(command);
                clearInterval(progressInterval);
                this.uploadProgress = 100;
                this.importResult = response;
                console.log("response.existingSystemFound && response.existingSystem", response.existingSystemFound && response.existingSystem, response);
                if (response.success) {
                    let successMsg = `System imported successfully! System ID: ${response.systemId}`;
                    if (response.archivedSystemId) {
                        successMsg += ` Previous system (ID: ${response.archivedSystemId}) was archived.`;
                    }
                    else if (response.overriddenSystemId) {
                        successMsg += ` Existing system was updated with imported data.`;
                    }
                    Notifier.onOk(successMsg);
                    this.$emit("importCompleted", response);
                    // Clear the warning since import was successful
                    this.existingSystemWarning = null;
                    this.showExistingSystemWarning = false;
                    this.selectedImportOption = null;
                    this.archiveExisting = false;
                    // Auto-close modal after 3 seconds on success
                    setTimeout(() => {
                        if (this.show) {
                            this.show = false;
                        }
                    }, 3000);
                }
                else if (response.existingSystemFound && response.existingSystem) {
                    console.warn("Existing system found during import:", response.existingSystem);
                    // Hide progress bar when showing warning
                    this.uploadProgress = 0;
                    // Handle existing system found
                    this.existingSystemWarning = {
                        message: response.message || "An existing system was found.",
                        isDifferentLocation: response.existingSystemInDifferentLocation || false,
                        overrideAllowed: response.overrideAllowed || false,
                        existingSystem: {
                            systemId: response.existingSystem.systemId || 0,
                            systemName: response.existingSystem.systemName || "",
                            serialNumber: response.existingSystem.serialNumber || "N/A",
                            siteName: response.existingSystem.siteName || "",
                            companyName: response.existingSystem.companyName || "",
                            companyId: response.existingSystem.companyId || 0,
                            siteId: response.existingSystem.siteId || 0
                        }
                    };
                    this.showExistingSystemWarning = true;
                    this.selectedImportOption = null;
                    this.archiveExisting = false;
                    if (response.existingSystemInDifferentLocation) {
                        Notifier.onError("Controller found in different location. Please review and confirm to proceed.");
                    }
                    else {
                        Notifier.onWarning("Existing system found. Please choose how to proceed.");
                    }
                }
                else {
                    // Hide progress bar on other failures
                    this.uploadProgress = 0;
                    Notifier.onError(response.message || ((_c = response.errors) === null || _c === void 0 ? void 0 : _c.join(" ")) || "Import failed");
                }
            }
            catch (ex) {
                this.uploadProgress = 0;
                HttpHelper.handleResponse(ex, () => {
                    UploadErrorHelper.notify(ex);
                });
                // Create error result, showing the server's reason (e.g. a rejected file) rather than
                // the generated client's generic exception text.
                this.importResult = new ImportControllerDataFromZipResponseModel({
                    success: false,
                    message: UploadErrorHelper.getMessage(ex) || "An error occurred during import",
                    errors: []
                });
                // Clear existing system warning on error
                this.existingSystemWarning = null;
                this.showExistingSystemWarning = false;
                this.selectedImportOption = null;
                this.archiveExisting = false;
            }
            finally {
                this.uploading = false;
            }
        });
    }
    readFileAsBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result;
                // Remove the data URL prefix (e.g., "data:application/zip;base64,")
                const base64 = result.split(',')[1];
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }
    get filteredSites() {
        if (!this.selectedCompany) {
            return [];
        }
        const sites = (this.sites || [])
            .filter(site => site.companyId === this.selectedCompany.value)
            .map(site => ({
            value: site.siteId,
            text: site.siteName || ""
        }));
        return sites;
    }
    get canImport() {
        var _a;
        const basicRequirements = !this.uploading &&
            this.selectedCompany !== null &&
            this.selectedSite !== null &&
            this.selectedFile !== null;
        // If there's an existing system warning, user must select an option
        if (this.showExistingSystemWarning) {
            if ((_a = this.existingSystemWarning) === null || _a === void 0 ? void 0 : _a.isDifferentLocation) {
                // Different location: must check archive box
                return basicRequirements && this.archiveExisting;
            }
            else {
                // Same location: must select override or archive
                return basicRequirements && this.selectedImportOption !== null;
            }
        }
        return basicRequirements;
    }
    get getButtonVariant() {
        if (this.existingSystemWarning && this.selectedImportOption === 'override') {
            return 'info';
        }
        else if (this.existingSystemWarning && (this.selectedImportOption === 'archive' || this.archiveExisting)) {
            return 'warning';
        }
        return 'primary';
    }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
], ImportSystemFromZipModal.prototype, "companies", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
], ImportSystemFromZipModal.prototype, "sites", void 0);
__decorate([
    Watch("selectedCompany"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ImportSystemFromZipModal.prototype, "onCompanyChanged", null);
__decorate([
    Watch("selectedSite"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ImportSystemFromZipModal.prototype, "onSiteChanged", null);
ImportSystemFromZipModal = __decorate([
    Component({
        components: { Multiselect },
        expose: ["showModal"],
        emits: ["importCompleted"]
    })
], ImportSystemFromZipModal);
export default ImportSystemFromZipModal;
